import styled from 'styled-components';
import { StyledAccordionItemProps } from './AccordionItem.types';

export const StyledAccordion = styled.div<StyledAccordionItemProps>`
  position: relative;
  cursor: pointer;

  .accordion__button {
    display: flex;
    justify-content: space-between;
  }

  .accordion__toggle-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ${(props) => props.customStyle}
`;

export const Title = styled.div``;
